export const WorkflowTabHeaderName = 'WorkflowTabHeaderComponent';
